import { message } from 'antd'
import { useEffect } from 'react'

interface IScriptOptions {
  mountToElementWithId?: string
  attributes?: { [key: string]: string | boolean | number | undefined }
  onError?: (event: Event | string) => void
  onLoad?: (event: Event | string) => void
  onReady?: () => void
}

export const useScript = (src: string, options: IScriptOptions = {}) => {
  useEffect(() => {
    if (options?.onReady) options.onReady()
    const parentId = options?.mountToElementWithId
    const parent = parentId ? document.getElementById(parentId) : document.body
    if (!parent) {
      console.error(`Element with id '${parentId}' missing when trying to mounting script: ${src}`)
      message.error('Faild to mount script')
      return
    }
    const defaultAttributes = { async: true, defer: true }
    const attributes = options?.attributes
      ? { ...defaultAttributes, ...options.attributes }
      : defaultAttributes
    const script = document.createElement('script')
    script.src = src
    Object.keys(attributes).forEach((key: string) => {
      script.setAttribute(key, attributes[key])
    })
    parent.appendChild(script)
    script.onerror = (event) => {
      if (!options?.onError) return
      options.onError(event)
      if (parent.contains(script)) {
        parent.removeChild(script)
      }
    }

    script.onload = (event) => {
      if (!options?.onLoad) return
      options.onLoad(event)
    }

    return () => {
      if (parent.contains(script)) {
        parent.removeChild(script)
      }
    }
  }, [])
}
